/* eslint-disable unicorn/filename-case */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { forwardRef, useEffect, useRef } from 'react'
import { Platform, useWindowDimensions, ViewStyle } from 'react-native'
import { Audio, ResizeMode, Video, VideoProps } from 'expo-av'
import { Box } from 'native-base'

// import { useConfig } from '../../../hooks'

export const useVideoComponent = () => {
  // const { OS } = Platform
  // const isWeb = OS === 'web'
  const ref = useRef<Video>(null)

  const playVideo = () => {
    ref.current?.playAsync()
  }

  const pauseVideo = () => {
    ref.current?.pauseAsync()
  }

  return { Video: VideoExpo, ref, playVideo, pauseVideo }
}

type props = VideoProps & {
  style?: ViewStyle
}

export const VideoExpo = forwardRef<Video, props>((props, ref) => {
  const { height } = useWindowDimensions()
  const { style, ...rest } = props
  // const config = useConfig()

  useEffect(() => {
    const enableAudio = async () => {
      await Audio.setAudioModeAsync({
        allowsRecordingIOS: false,
        playsInSilentModeIOS: true,
        staysActiveInBackground: false,
        shouldDuckAndroid: false
      })
    }

    enableAudio()
  }, [])

  return (
    <Box
      // @ts-expect-error 900px maxwidth is for web. Anyone who adds a new props here should remove this comment first
      style={{
        maxWidth: Platform.OS === 'web' ? '900px' : '100%',
        // maxWidth: '900px',
        maxHeight: height,
        width: '100%',
        height: '100%'
      }}
    >
      <Video
        ref={ref}
        resizeMode={ResizeMode.CONTAIN}
        style={[
          {
            width: '100%',
            height: '100%',
            position: 'relative',
            zIndex: 9
          },
          style
        ]}
        {...rest}
      />
    </Box>
  )
})
